import type { LinariaClassName } from '@linaria/core'
import { memo } from 'react'
import IconButton from '../../../Buttons/IconButton'
import Pin from '../../../Icons/Pin'
import Container from '../Container'

interface PinButtonProps {
    className?: LinariaClassName
    title?: string
    size: number
    filled?: boolean
    shadow?: boolean
    color?: string
    onClick?: any
}

const PinButton = memo((props: PinButtonProps) => {
    const { className, title, size, filled, shadow, color, onClick } = props

    return (
        <Container className={className} shadow={shadow} title={title}>
            <IconButton
                title={title}
                onClick={onClick}
                data-testid="Container__PinButton"
            >
                <Pin color={color ?? '#fff'} size={size} filled={filled} />
            </IconButton>
        </Container>
    )
})

export default PinButton
export { PinButton }
